<template>
  <div class="course-chapter-module">
    <el-dialog title="查看章节" :visible.sync="dialogVisible" width="880px" :before-close="handleClose">
      <el-form :model="filter" label-width="80px" size="small" inline>
        <el-form-item label="章节名称">
          <el-input v-model="filter.name" maxlength="20" placeholder="请输入章节名称" clearable />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="search">搜索</el-button>
          <el-button type="" size="small" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <el-card>
        <el-button type="primary" size="small" style="margin-bottom: 10px;" @click="add">添加</el-button>
        <el-table :data="chapterList" border>
          <el-table-column align="center" label="排序号" prop="sortNum">
            <template v-slot="{ row }">
              <el-input-number v-model="row.sortNum" step-strictly :controls="false" class="edit-sort-num" @change="handleChangeSortNum(row.id, row.sortNum, $event)" />
            </template>
          </el-table-column>
          <el-table-column align="center" label="章节名称" prop="name" />
          <el-table-column align="center" label="更新时间" prop="lastUpdateDate" min-width="100" />
          <el-table-column align="center" label="最后操作人" prop="updateByUserName" min-width="100" />
          <el-table-column align="center" label="操作" min-width="100">
            <template v-slot="{ row }">
              <el-button type="text" @click="edit(row)">编辑</el-button>
              <el-button type="text" @click="del(row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 10px; text-align: center;"
          :current-page="filter.page"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="filter.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </el-card>
      <span slot="footer" class="dialog-footer" />
    </el-dialog>
    <!-- 章节管理(添加 or 编辑) -->
    <el-dialog :title="title" :visible.sync="manageDialogVisible" width="600px" :before-close="handleCloseManage">
      <el-form :model="manageForm" :rules="manageRules" ref="manageForm" label-width="80px" size="small">
        <el-form-item label="章节名称" prop="name">
          <el-input v-model="manageForm.name" maxlength="20" placeholder="请输入章节名称" />
        </el-form-item>
        <el-form-item label="排序号" prop="sortNum">
          <el-input-number v-model="manageForm.sortNum" :min="1" :controls="false" placeholder="请输入排序号" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCloseManage">取 消</el-button>
        <el-button type="primary" size="small" @click="manageChapter()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getChapterPageList,
  addCourseChapter,
  updateCourseChapter,
  delCourseChapter,
} from '@/api/product/courseManage'

export default {
  name: 'CourseChapter',

  data() {
    return {
      dialogVisible: false,
      courseId: null,
      filter: {
        page: 1,
        limit: 10,
        name: null
      },
      total: 0,
      chapterList: [],
      title: '',
      manageDialogVisible: false,
      editId: null,
      manageForm: {
        name: '',
        sortNum: undefined
      },
      manageRules: {
        name: [
          { required: true, message: '请输入章节名称', trigger: 'blur' }
        ],
        sortNum: [
          { required: true, message: '请输入排序号', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      const d = this.$options.data()
      this.filter = d.filter
      this.total = d.total
      this.chapterList = d.chapterList
      this.editId = d.editId
    },
    show(id) {
      this.init()
      this.courseId = id
      this.search()
      this.dialogVisible = true
    },
    // 搜索
    search() {
      this.filter.page = 1
      this.getList()
    },
    // 重置
    reset() {
      this.filter = this.$options.data().filter
      this.getList()
    },
    getList() {
      const params = {
        courseId: this.courseId,
        ...this.filter
      }
      getChapterPageList(params).then(({ code, data, message }) => {
        if (code === 0) {
          this.chapterList = data.records
          this.total = parseInt(data.total, 10)
        } else {
          this.$message.error(message)
        }
      })
    },
    // 修改排序号
    handleChangeSortNum(id, num, sortNum) {
      updateCourseChapter({ id, sortNum })
        .then(({ code }) => {
          if (code === 0) {
            this.$message.success('修改排序号成功!')
            this.handleCloseManage()
            this.getList()
          }
        })
    },
    // 点击新增
    add() {
      this.title = '新增章节'
      this.manageDialogVisible = true
      this.$refs.manageForm && this.$refs.manageForm.resetFields()
    },
    // 点击编辑
    edit(row) {
      this.title = '编辑章节'
      this.editId = row.id
      this.manageDialogVisible = true
      this.$nextTick(() => {
        this.$refs.manageForm && this.$refs.manageForm.resetFields()
        this.manageForm = {
          name: row.name,
          sortNum: row.sortNum
        }
      })
    },
    del(id) {
      this.$confirm(`确认删除当前章节?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await delCourseChapter({ id })
        if (res.code !== 0) return this.$message.error(res.message)
        this.$message.success('删除成功!')
        this.getList()
      })
    },
    // 提交
    manageChapter() {
      this.$refs.manageForm.validate(async(valid) => {
        if (valid) {
          const params = {
            courseId: this.courseId,
            ...this.manageForm
          }
          if (!this.editId) {
            addCourseChapter(params)
              .then(({ code }) => {
                if (code === 0) {
                  this.$message.success('新增章节成功!')
                  this.handleCloseManage()
                  this.getList()
                }
              })
          } else {
            updateCourseChapter({ id: this.editId, ...params })
              .then(({ code }) => {
                if (code === 0) {
                  this.$message.success('编辑章节成功!')
                  this.handleCloseManage()
                  this.getList()
                }
              })
          }
        }
      })
    },
    handleClose() {
      this.courseId = null
      this.filter = this.$options.data().filter
      this.dialogVisible = false
      this.$emit('close')
    },
    handleCloseManage() {
      this.manageForm = this.$options.data().manageForm
      this.manageForm.sortNum = ''
      this.manageForm.id = ''
      this.title = ''
      this.editId = ''
      this.manageDialogVisible = false
    },
    handleSizeChange(v) {
      this.filter.page = 1
      this.filter.limit = v
      this.getList()
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.getList()
    }
  },
}
</script>

<style lang="scss" scoped>
.edit-sort-num {
  width: 100%;
  box-sizing: border-box;
  ::v-deep .el-input__inner {
    border: none;
  }
}
</style>
